export function showError(message) {
    alert(message);
}
